import { Col } from 'components/Col';
import { GenericModal } from 'components/GenericModal';
import { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from 'store/modules/ModalActions';

interface Props {
  modalKey: string;
  title: string | JSX.Element;
  text: {
    subtitle: string | JSX.Element;
    text: (string | JSX.Element)[];
  }[];
}
export default function InfosCamposModal(props: Props) {
  const d = useDispatch();
  return (
    <GenericModal
      title={props.title}
      onClose={() => {
        d(closeModal(props.modalKey));
      }}
    >
      {props.text.map((section, i) => {
        return (
          <Fragment key={i}>
            <Col>
              <div style={{ fontWeight: '500' }}>{section.subtitle}</div>
              {section.text.map((text, ii) => {
                return (
                  <span key={`${i}_${ii}`}>
                    {text}
                    <br />
                  </span>
                );
              })}
            </Col>
            {i < props.text.length - 1 ? <hr /> : <Fragment />}
          </Fragment>
        );
      })}
    </GenericModal>
  );
}
